export const formatLoginDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
};

export const getOutcomeColor = (outcome) => {
  switch (outcome) {
    case 'success':
      return '#2E7D32';
    case 'unauthorized':
      return '#F57F17';
    case 'failed':
      return '#C62828';
    default:
      return '#616161';
  }
};

// `value` is sent straight through as the API's `outcome` query param, which
// accepts a comma separated list.
export const OUTCOME_FILTERS = [
  { value: '', label: 'All outcomes' },
  { value: 'unauthorized,failed', label: 'Unauthorized & failed' },
  { value: 'success', label: 'Successful' },
  { value: 'unauthorized', label: 'Unauthorized' },
  { value: 'failed', label: 'Failed' },
];

export const buildDashboardFilters = (tenants = []) => [
  { value: '', label: 'All dashboards' },
  ...tenants.map((tenant) => ({
    value: tenant.key,
    label: tenant.name,
  })),
  { value: 'none', label: 'No dashboard' },
];

// Keep the old name as an alias so any leftover imports keep working.
export const buildTenantFilters = buildDashboardFilters;

export const buildDomainFilters = (domains = []) => [
  { value: '', label: 'All domains' },
  ...domains.map((domain) => ({
    value: domain,
    label: `@${domain}`,
  })),
];

export const getDashboardDisplayName = (tenantKey, tenants = []) => {
  if (!tenantKey) return '—';
  const match = tenants.find((tenant) => tenant.key === tenantKey);
  return match?.name || tenantKey;
};

export const getAuth0UserProfileUrl = (auth0Id) => {
  if (!auth0Id) return null;
  const baseUrl = process.env.REACT_APP_AUTH0_PROFILE_BASE_URL;
  if (!baseUrl) return null;
  return `${baseUrl}${encodeURIComponent(auth0Id)}`;
};
